/**
 * 開発時にtrueにして使用。
 * 現実世界の GPS と SVG 座標を対応付けるために利用し、
 * 対応付けが終わったら false に戻すこと。
 */
export const USE_MOCK_GPS = false;

export const MOCK_LOCATION = {
  lat: 35.7210754776702,
  lng: 139.69479804305513,
  acc: 1,
};
